import { useCallback } from 'react';

interface InvalidFeedbackProps {
    error: any;
    className?: any;
}

function InvalidFeedback({ error, className = '' }: InvalidFeedbackProps) {

    
    const getType = useCallback(() => {
        switch (error?.type) {
            case 'required':
                return `Campo requerido`
            case 'maxLength':
                return `Sólo se permiten máximo ${error.message} caracteres`
            case 'minLength':
                return `Se require un mínimo de ${error.message} caracteres`
            case 'min':
                return `${error.message}`
            case 'max':
                return `${error.message}`
            case 'pattern':
            case 'custom':
                return `${error.message}`
        
            default:
                return error?.type
        }
		
    }, [error?.type])

    return error ? <span className={`invalid-feedback ${className}`}>{getType()}</span> : <></>
}

export default InvalidFeedback